<ul>
  <div *ngIf="nodes===undefined">Loading...</div>
  <li *ngFor="let node of nodes">
    <i class="fa" [routerLink]="[]" [ngClass]="node.getIconClass()" (keypress)="keyPressExpand($event, node)" (click)="expand(node)"></i>
    <span class="name" [routerLink]="[]" (keypress)="keyPressNode($event, node)" (click)="nodeClicked(node)">{{node.name}}</span>
    <div *ngIf="node.isExpanded">
      <app-service-tree [nodes]="node.childrens" (nodeSelected)="nodeSelecetedChild($event)"></app-service-tree>
    </div>
  </li>
</ul>